__turbopack_context__.v({
  "Footer": "widget-module-scss-module__zsOl_a__Footer",
  "WidgetFooterText": "widget-module-scss-module__zsOl_a__WidgetFooterText",
  "WidgetHeader": "widget-module-scss-module__zsOl_a__WidgetHeader",
  "WidgetHeaderTitle": "widget-module-scss-module__zsOl_a__WidgetHeaderTitle",
  "WidgetModal": "widget-module-scss-module__zsOl_a__WidgetModal",
  "WidgetModalContainer": "widget-module-scss-module__zsOl_a__WidgetModalContainer",
  "WidgetModalHeader": "widget-module-scss-module__zsOl_a__WidgetModalHeader",
  "WidgetQuestion": "widget-module-scss-module__zsOl_a__WidgetQuestion",
  "WidgetQuestions": "widget-module-scss-module__zsOl_a__WidgetQuestions",
  "WidgetSmall": "widget-module-scss-module__zsOl_a__WidgetSmall",
  "WidgetWrapper": "widget-module-scss-module__zsOl_a__WidgetWrapper",
});
